export default __webpack_public_path__ + "static/media/gold.43944f36.svg";